/**
 * This source code is and remains the property of UserZoom Technologies Inc (sucursal en España).
 * Dissemination of this information or reproduction of this material is strictly
 * forbidden unless prior written permission is obtained from
 * UserZoom Technologies Inc (sucursal en España) (https://www.userzoom.com).
 **/

import { css } from 'styled-components';
import Input from '@userzoomlibraries/toolkit-input';
import { UiBreakpoint } from '../../../../utils/constants';

const WelcomePageStyles = css`
	.questions-wrapper {
		display: flex;
		flex-direction: column;
		margin: 0 auto;
		max-width: 672px;
		width: 100%;
	}

	.pec-study-layout-content {
		padding-bottom: 100px;
	}

	.content {
		&.with-bullet {
			margin-left: 32px;

			.question-error {
				margin-left: 32px;
			}
		}
	}

	.instructions {
		font-weight: 400;
		font-size: 16px;
		color: var(--color-grey800);
		margin-bottom: 8px;
	}

	${Input} {
		padding: 6px;
		font-size: 16px;
	}

	@media (max-width: ${UiBreakpoint}px) {
	}
`;

export default WelcomePageStyles;
